import { render, staticRenderFns } from "./termsOfService.vue?vue&type=template&id=15d85e6d&scoped=true&"
import script from "./termsOfService.vue?vue&type=script&lang=js&"
export * from "./termsOfService.vue?vue&type=script&lang=js&"
import style0 from "./termsOfService.vue?vue&type=style&index=0&id=15d85e6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d85e6d",
  null
  
)

export default component.exports